/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Notification_Stock_Out_DoneInputs */

const vi_notification_stock_out_done = /** @type {(inputs: Notification_Stock_Out_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn ${i?.code} đã đóng xong`)
};

/**

* @param {Notification_Stock_Out_DoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notification_stock_out_done = /** @type {((inputs: Notification_Stock_Out_DoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Stock_Out_DoneInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notification_stock_out_done(inputs)
});